//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { AppThunk } from '@models/AppState';

/**
 * Create a redux thunk.
 *
 * This is a type-inference helper, to make sure (dispatch, getState), and return type
 * all get inferred properly.
 * @param thunker Thunk Action Creator
 */
export const createThunk = <Args extends Array<unknown>, Ret>(
  thunker: (...args: Args) => AppThunk<Ret>
) => thunker;

// This is like createThunk, but applied at the next layer down.
// e.g.
// createThunk(() => (dispatch, getState) => {})
// vs
// () => thunkify((dispatch, getState) => {})
//
// export const thunkify = <T>(thunk: AppThunk<T>) => thunk;
